import styled from "styled-components";
import Colors from "def/Colors";

export const WalmartLinkContainer = styled.a`
    color: ${Colors.PALETTE.BLUE_GRAY._200};
    text-decoration: none;
    position: absolute;
    padding: 5px 2px 2px 5px;
    right: 0;
    bottom: 0;
  &:hover {
    text-decoration: underline;
  }
`
